import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import "../../Styles/SuperAdminTenantRemoval.scss";
import SuperAdminFetchTenant from "./SuperAdminFetchTenant";
import Images from "../../Assets/Images";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../Action/SuperAdmin/FetchTenant";

class SuperAdminTenantRemove extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    // if (nextProps.loggedInStatus != null){
    //     nextProps.history.push('/superadmindashboard')
    //     return {null: nextProps.actions.LoginSatus(null)}
    // }
    if (nextProps.tenantDataFailure != null) {
      nextProps.history.push("/");
      // secureLocalStorage.clear();
      return { null: nextProps.actions.TenantDataFail(null) };
    }
    return null;
  }

  handleSearch = (e) => {
    const { actions } = this.props;
    let searchKey = e.target.value;
    actions.TenantSearchKey(searchKey);
  };

  render() {
    const { loaderStatus, tenantSearchKey } = this.props;
    return (
      <div className="rm-tanent-cont">
        <div className="rm-tenant-removal">
          <div className="rm-table-cont relPosition">
            {/* Spinner */}
            {loaderStatus ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}

            <div className="rm-tbl-head">
              <div className="d-flex">
                <h6>Active / Inactive Tenants</h6>
                <div className="ml-auto">
                  <div className="rm-search">
                    <span>
                      <img src={Images.SEARCH} width="14" alt="search" />
                    </span>
                    <input
                      type="text"
                      name="search"
                      className={"form-control"}
                      placeholder=" Search"
                      value={tenantSearchKey}
                      onChange={this.handleSearch}
                      onKeyPress={this.handleSearch}
                    />
                    {/* <input type="text" placeholder="Search" /> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="tenentTable">
              <div className="ag-theme-alpine" style={{ width: "100%" }}>
                <SuperAdminFetchTenant />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => {
  return {
    loaderStatus: state.FetchTenant.loaderStatus,
    tenantDataFailure: state.FetchTenant.tenantDataFail,
    tenantSearchKey: state.FetchTenant.tenantSearchKey,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SuperAdminTenantRemove);
